export function originHeaders(viewIsPaid) {
  let header = [
    {
      text: 'STT',
      value: 'stt',
      align: 'center',
      sortable: false,
      show: true,
      width: '4%',
    },
    {
      text: 'Học sinh',
      value: 'name',
      align: 'left',
      sortable: false,
      show: true,
      width: '24%',
    },
    {
      text: 'Ngày sinh',
      value: 'dob',
      align: 'left',
      sortable: false,
      show: true,
      width: '12%',
    },
    {
      text: 'Lớp',
      value: 'currentClass',
      align: 'left',
      sortable: false,
      show: true,
      width: '8%',
    },
    {
      text: 'Tổng số tiền thu',
      value: 'moneyTotal',
      align: 'left',
      sortable: false,
      show: true,
      width: '10%',
    },
    {
      text: 'Tổng số tiền đã nộp',
      value: 'amountPaid',
      align: 'right',
      sortable: false,
      show: true,
      width: '10%',
    },
    {
      text: 'Thao tác',
      value: 'action',
      align: 'center',
      sortable: false,
      show: true,
      width: '8%',
    },
  ]
  if (viewIsPaid) {
    header.splice(6, 0, {
      text: 'Đã thu',
      value: 'isPaid',
      align: 'center',
      sortable: false,
      show: true,
      width: '8%',
    })
  }
  return header
}
export const headerExcel = [
  {
    text: 'Tên học sinh',
    value: 'name',
  },
  {
    text: 'Mã số',
    value: 'code',
  },
  {
    text: 'Ngày sinh',
    value: 'dob',
  },
  {
    text: 'Giới tính',
    value: 'gender',
  },
  {
    text: 'Lớp',
    value: 'class',
  },
  {
    text: 'Trạng thái',
    value: 'status',
  },
  {
    text: 'Ghi chú',
    value: 'notes',
  },
  {
    text: 'Tổng số tiền thu',
    value: 'totalMoney',
  },
]
